export default __webpack_public_path__ + "static/media/lock.303f0684.svg";